export default function Machines_A_6 (number = 1) {
  return {
    name: '蓄电池',
    icon: '/static/img/machines/a6.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_A/Machines_A_6.js